/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostTagBatchResponse {
    getFixupPrototypeFunction() { return CostTagBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<CostTagBatchResponse>): CostTagBatchResponse {
        let obj = Object.assign(new CostTagBatchResponse(), model);
        CostTagBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostTagBatchResponse>): CostTagBatchResponse {
        if (!model) return null;
        return CostTagBatchResponse.newInstance(<CostTagBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostTagBatchResponse) {
        if (!obj) return;

        models.CostTagBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostTagBatchResponse): boolean {
        Object.setPrototypeOf(obj, CostTagBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.CostTag.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.CostTag; };

}
